




























































import { Component, Vue, Prop, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";
import PageInitialMixin from "@/mixins/PageInitialMixin";
// 内容层级
import ContentLayer from '@/layers/ContentLayer.vue';
import ScanTitle from "@/components/common/index/ScanTitle.vue";
import EditFooter from "@/components/common/edit/EditFooter.vue";
import IndexContactInfo from "@/components/common/index/IndexContactInfo.vue";
import IndexInstitutionIntroList from "@/components/common/index/IndexInstitutionIntroList.vue";
import BarrageIndex from "@/components/common/index/BarrageIndex.vue";
import IndexRuleIntro from "@/components/common/index/IndexRuleIntro.vue";
import ActivitySection from "./components/common/ActivitySection.vue";
import GachaLoading  from "./components/common/GachaLoading.vue";
import ActivityLink from "@/components/common/index/ActivityLink.vue"

import GachaMainImg from "./components/index/GachaMainImg.vue";
import GachaTwistSection from "./components/index/GachaTwistSection.vue"
import GachaCountDown from "./components/index/GachaCountDown.vue";
import GachaTitleSection from "./components/index/GachaTitleSection.vue";
import GachaProgress from "./components/index/GachaProgress.vue";
import GachaPrizeCard from "./components/index/GachaPrizeCard.vue";
import GachaToastModal from "./components/index/GachaToastModal.vue";
import GachaCardModal from "./components/index/GachaCardModal.vue";
import GachaRank from "./components/index/GachaRank.vue";

//图标层级
import IconLayer from '@/layers/IconLayer.vue';
import BGMIcon from "@/components/common/index/BGMIcon.vue";
import ContactIcon from "@/components/common/index/ContactIcon.vue";
import PosterIcon from "@/components/common/index/PosterIcon.vue";
import ShareIcon from "@/components/common/index/ShareIcon.vue";
import RecruitIcon from '@/components/common/index/RecruitIcon.vue';
import InviteIcon from '@/components/common/index/InviteIcon.vue';
import MicroWebsiteIcon from '@/components/common/index/MicroWebsiteIcon.vue';


// 底部按钮层级
import FooterLayer from '@/layers/FooterLayer.vue';
import OneClickFooter from '@/components/common/index/OneClickFooter.vue';
import CheckFooter from '@/components/common/index/CheckFooter.vue';
import DemoFooter from "@/components/common/index/DemoFooter.vue";
import MaskLayer from '@/layers/MaskLayer.vue';

import getUrlParam from '@/common/utils/getUrlParam';
import fetch from "@/common/api/fetch";
import { AxiosPromiseData, AxiosPromiseError } from "@/common/interface";

//音乐
@Component({
  components: {
    "gacha-loading":GachaLoading,
    "content-layer": ContentLayer,
    "scan-title": ScanTitle,
    "edit-footer": EditFooter,
    "activity-section": ActivitySection,
    "index-contact-info": IndexContactInfo,
    "index-institution-intro-list": IndexInstitutionIntroList,
    "activity-link": ActivityLink,
    "barrage-index": BarrageIndex,
    "gacha-main-img": GachaMainImg,
    "gacha-twist-section": GachaTwistSection,
    "gacha-count-down":GachaCountDown,
    "gacha-title-section":GachaTitleSection,
    "gacha-progress":GachaProgress,
    "gacha-prize-card":GachaPrizeCard,
    "gacha-toast-modal":GachaToastModal,
    "gacha-card-modal":GachaCardModal,
    "gacha-rank":GachaRank,
    "index-rule-intro": IndexRuleIntro,
    "icon-layer": IconLayer,
    "bgm-icon": BGMIcon,
    "contact-icon": ContactIcon,
    "poster-icon": PosterIcon,
    "share-icon": ShareIcon,
    "recruit-icon": RecruitIcon,
    "invite-icon": InviteIcon,
    "microWebsite-icon": MicroWebsiteIcon,
    
    
    "footer-layer": FooterLayer,
    "check-footer": CheckFooter,
    "demo-footer": DemoFooter,
    "one-click-footer": OneClickFooter,
    "mask-layer": MaskLayer
  }
})
export default class GroupIndex extends Mixins(PageInitialMixin) {
  @Getter("gachaTypeParameter") gachaTypeParameter!: object;
  @Getter("showBarrage") showBarrage!: boolean;
  @Getter("showData") showData!: boolean;
  @Getter("mainBackgroundColor") mainBackgroundColor!: string;
  @Getter("uid") uid!: string;
  @Getter("urlUid") urlUid!: string;
  @Getter("gachaLoading") gachaLoading!: boolean;
  @Getter("showWesiteBtn") showWesiteBtn!: boolean;

  @Getter("institutionTitle") institutionTitle!: string;
  @Getter("institutionSwitch") institutionSwitch!: string;
  @Getter("contactSwitch") contactSwitch!: boolean;
  @Getter("contactTitle") contactTitle!: boolean;
  @Getter("activitySwitch") activitySwitch!: boolean;
  @Getter("activityTitle") activityTitle!: boolean;

  getUrlParam: Function = getUrlParam;
  showToast: boolean = false;
  showCard: boolean = false;
  isloop :boolean = true;
  gachaToastData:any= "";
  showScanTitle: boolean = false;

  mounted() {
    setTimeout(() => {
      this.showScanTitle = this.showData == undefined ? true : this.showData;
    }, 2000);
  }
 

  showGachaToastModal(data:any){
    this.gachaToastData = data;
    this.showToast = true;
  }
  hideToastModal(){
    this.showToast = false;
  }
  hideCardModal(){
    this.showCard = false;
  }
  showCardModal(){
    this.showCard = true;
  }
}
